var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.530421, 0.53024, -0.53024, 0.530421, 24.004414, -4.121804)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 26.497445 26.500077 L 218.885742 26.499746 ",
    stroke: "#003c70",
    strokeWidth: 53,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.530421, 0.53024, -0.53024, -0.530421, 154.156355, 23.990483)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 26.496952 26.49943 L 218.88525 26.499761 ",
    stroke: "#003c70",
    strokeWidth: 53,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuit);
export default __webpack_public_path__ + "static/media/quit.ab8334277b46eca6436645acdaaceed5.svg";
export { ForwardRef as ReactComponent };